document.addEventListener('DOMContentLoaded', function () {
    // Convert legacy modal attributes to Bootstrap 5 equivalents
    document.querySelectorAll('[data-toggle="modal"]').forEach(function (el) {
        const target = el.getAttribute('data-target');
        if (target) {
            el.setAttribute('data-bs-toggle', 'modal');
            el.setAttribute('data-bs-target', target);
        }
    });

    document.querySelectorAll('[data-dismiss="modal"]').forEach(function (el) {
        el.setAttribute('data-bs-dismiss', 'modal');
    });

    // Polyfill jQuery modal calls if widget uses them
    if (typeof $ !== 'undefined') {
        $.fn.modal = function (action) {
            return this.each(function () {
                const modal = bootstrap.Modal.getOrCreateInstance(this);
                if (action === 'show') modal.show();
                if (action === 'hide') modal.hide();
            });
        };
    }
});